module.exports = __webpack_public_path__ + "static/img/logo-dlt.ab3383a2.png";